import { createContext } from 'react';
import getConfig from 'next/config';
import qs from 'qs';
import express from 'express';
// import {
//   NEW_TAXONOMY_VARIATION,
//   NEW_TAXONOMY_COOKIE_ID,
//   TAXONOMY_EXPERIMENT_ID,
// } from './useVariation';

const RequestContext = createContext(null);

const FORCE_TAXONOMY = false;
const FORCE_NEW_TAXONOMY = true;

export default RequestContext;

export type RequestData = {
  hostname: string;
  query: any;
  contentServiceHost: string;
  useNewTaxonomy?: boolean;
};

const {
  publicRuntimeConfig: { APP_ENV, CONTENT_SERVICE_HOST },
} = getConfig();

const getContentServiceHostFromCookies = (cookies: string): string => {
  let host = CONTENT_SERVICE_HOST;

  cookies
    .split(';')
    .map(kv => kv.trim().split('='))
    .forEach(([k, v]) => {
      if (k === 'content_branch') {
        host = `https://${v}-content.qa.education.com`;
      }
    });

  return host;
};

const isNewTaxonomyInRequest = (): // cookies: string,
// queryParams: object
boolean => {
  // const taxonomyVariationString = NEW_TAXONOMY_VARIATION.toString();
  // // First check the query params (server-side only)
  // if (TAXONOMY_EXPERIMENT_ID in queryParams) {
  //   return queryParams[TAXONOMY_EXPERIMENT_ID] === taxonomyVariationString;
  // }
  //
  // // If we don't find it, check the cookies
  // let isNewTaxonomy = false;
  // cookies
  //   .split(';')
  //   .map(kv => kv.trim().split('='))
  //   .forEach(([k, v]) => {
  //     if (k === NEW_TAXONOMY_COOKIE_ID && v === taxonomyVariationString) {
  //       isNewTaxonomy = true;
  //     }
  //   });
  //
  // return isNewTaxonomy;
  return FORCE_NEW_TAXONOMY;
};

export function getRequestDataFromRequest(req?: express.Request): RequestData {
  const requestData = {
    hostname: 'www.giveuptobacco.com',
    query: {},
    contentServiceHost: CONTENT_SERVICE_HOST,
    referrer: '',
    useNewTaxonomy: false,
  };

  if (req) {
    requestData.hostname = req.hostname;
    requestData.query = req.query;

    // On QA, allow overriding content service host from a cookie
    if (APP_ENV === 'qa') {
      requestData.contentServiceHost = getContentServiceHostFromCookies(
        req.headers.cookie || ''
      );
    }

    requestData.referrer = req.headers.referer;
    requestData.useNewTaxonomy = isNewTaxonomyInRequest();
    // req.headers.cookie || '',
    // req.query
  } else if (typeof window !== 'undefined') {
    requestData.hostname = window.location.hostname;
    requestData.query = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    // On QA, allow overriding content service host from a cookie
    if (APP_ENV === 'qa') {
      requestData.contentServiceHost = getContentServiceHostFromCookies(
        document.cookie
      );
    }

    requestData.useNewTaxonomy = isNewTaxonomyInRequest();
    // document.cookie || '',
    // {}
  }

  requestData.useNewTaxonomy = FORCE_NEW_TAXONOMY;

  return requestData;
}
